import React from 'react'
import classNames from 'classnames'

import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles'

import { IUserInfoResponse, IUser, StorePremiumProduct } from 'protos'

import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'

import T from 'components/FormattedMessage'
import Currency from 'components/Currency'
import LabeledValue from 'components/LabeledValue'
import avatarPlaceholder from 'assets/images/default_user_avatar.png'

import placeholder from './assets/placeholder.png'
import goldBackground from './assets/background_premium_gold.jpg'
import silverBackground from './assets/background_premium_silver.jpg'

export interface Props {
  wins?: IUserInfoResponse['gamesWon']
  username?: IUser['name']
  winnings?: IUserInfoResponse['prizeTotal']
  avatarUrl?: IUser['photoUrl']
  playedGames?: IUserInfoResponse['gamesTotal']
  premiumMembership?: IUserInfoResponse['activePremium']
}

// TODO: The premium backgrounds added by copy-paste pattern.
//       Maybe it should put this in a separate component.
const styles = (theme: Theme) => createStyles({
  root: {
    paddingTop: theme.spacing() * 2,
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
    backgroundPositionY: 'top',
    backgroundRepeat: 'no-repeat',
  },
  gold: {
    backgroundImage: `url(${goldBackground})`,
    backgroundColor: theme.components.PremiumMembership.backgroundColor.gold,
    color: theme.components.PremiumMembership.color.gold,
  },
  silver: {
    backgroundImage: `url(${silverBackground})`,
    backgroundColor: theme.components.PremiumMembership.backgroundColor.silver,
    color: theme.components.PremiumMembership.color.silver,
  },
  row: {
    paddingBottom: theme.spacing() * 2,
  },
  avatar: theme.components.UserInfo.avatar,
})

type InjectedProps = Props & WithStyles<typeof styles>

const UserInfo: React.SFC<InjectedProps> = ({
  wins,
  classes,
  username,
  winnings,
  avatarUrl,
  playedGames,
  premiumMembership,
}) => {
  const isGold = !!premiumMembership && premiumMembership.type === StorePremiumProduct.Type.GOLD
  const isSilver = !!premiumMembership && premiumMembership.type === StorePremiumProduct.Type.SILVER

  return (
    <Grid
      className={classNames(classes.root, {
        [classes.gold]: isGold,
        [classes.silver]: isSilver,
      })}
      alignItems="stretch"
      direction="column"
      container
    >
      <Grid className={classes.row} item>
        <Grid alignItems="center" direction="column" container>
          <Grid item>
            <Typography color="inherit" variant="h5">
              {username || '-'}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid className={classes.row} item>
        <Grid alignItems="center" direction="column" container>
          <Grid item>
            <Avatar className={classes.avatar} src={avatarUrl || avatarPlaceholder} />
          </Grid>
        </Grid>
      </Grid>

      <Grid className={classes.row} item>
        <Grid alignItems="center" direction="row" container>
          <Grid xs={4} item>
            <LabeledValue
              labelVariant="h3"
              label={<T id="userprofile_stat_played" />}
              value={playedGames || 0}
            />
          </Grid>
          <Grid xs={4} item>
            <LabeledValue
              labelVariant="h3"
              label={<T id="userprofile_stat_winnings" />}
              value={winnings && <Currency value={winnings[0].value} currency={winnings[0].currency} />}
            />
          </Grid>
          <Grid xs={4} item>
            <LabeledValue
              labelVariant="h3"
              label={<T id="userprofile_stat_wins" />}
              value={wins || 0}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

UserInfo.defaultProps = {
  winnings: [{ value: 0 }],
  avatarUrl: placeholder,
}

export default withStyles(styles)(UserInfo)
